import {createStore, applyMiddleware, compose} from 'redux'
import thunk from 'redux-thunk'
import {sentryReduxEnhancer} from '../../core/utils/sentry'
import rootReducer from './rootReducer'

const enhancer = compose(
  applyMiddleware(thunk),
  sentryReduxEnhancer
)

export default function configureStore (initialState) {
  return createStore(
    rootReducer,
    initialState,
    enhancer
  )
}
